import { RatingsList } from "./ratings-list.tsx";
import { MentorshipFeedback } from "@/lib/api/mentorships.ts";
import { RatingsStats } from "./ratings-stats";

interface RatingsProps extends Omit<MentorshipFeedback, "teenWellBeing"> {}

export function Ratings({
  averageRating,
  ratingList,
  match,
  continue: continueFeedback,
}: RatingsProps) {
  return (
    <div className="flex flex-col gap-4">
      <RatingsStats
        averageRating={averageRating}
        match={match}
        continueFeedback={continueFeedback}
      />

      <RatingsList data={ratingList} />
    </div>
  );
}
